// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "elah-299d0.firebaseapp.com",
  "projectId": "elah-299d0",
  "storageBucket": "elah-299d0.firebasestorage.app",
  "messagingSenderId": "755027542740",
  "appId": "1:755027542740:web:36a1228f97021364adf141",
  "measurementId": "G-7LS6YT8Z9D",
  "apiKey": "AIzaSyAAqmNCXDgFDxht5W1et56Ib8o3-sQnKJM"
};
